import styled from "@emotion/styled/macro";
import { tokens } from "@sunrun/experience-ui-components";
import { Box } from "components/atoms/Box";

const TOOLTIP_WIDTH = 380;
const ARROW_HEIGHT = 14;
const ARROW_HALF_BASE = 10;
const CARD_HEIGHT = 200;
const TOOLTIP_HEIGHT = CARD_HEIGHT + ARROW_HEIGHT;

type SelfSupplyTooltipFlyoutProps = {
  x?: number;
  y?: number;
  datum?: {
    month: string;
    value: number;
    selfSupply: number;
    utilityImport: number;
  };
};

const Arrow = styled.div`
  width: 0;
  height: 0;
  border-left: ${ARROW_HALF_BASE}px solid transparent;
  border-right: ${ARROW_HALF_BASE}px solid transparent;
  border-top: ${ARROW_HEIGHT}px solid ${tokens.TINTS_INFO_80};
  margin: 0 auto;
`;

const TooltipTitle = styled(Box)`
  font-family: Roobert, sans-serif;
  font-size: 20px;
  font-weight: 600;
  color: ${tokens.BRAND_HEROBLUE};
`;

const TooltipRow = styled(Box)`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  font-family: Roobert, sans-serif;
  font-size: 16px;
  color: ${tokens.BRAND_HEROBLUE};
`;

const SelfSupplyTooltipFlyout = ({
  x = 0,
  y = 0,
  datum,
}: SelfSupplyTooltipFlyoutProps) => {
  if (!datum?.month) return null;

  const year = new Date().getFullYear();
  const { month, selfSupply, utilityImport } = datum;
  const tooltipX = x - TOOLTIP_WIDTH / 2;
  const tooltipY = Math.max(4, y - TOOLTIP_HEIGHT);

  return (
    <g style={{ pointerEvents: "none" }}>
      <foreignObject
        x={tooltipX}
        y={tooltipY}
        width={TOOLTIP_WIDTH}
        height={TOOLTIP_HEIGHT}
      >
        <div>
          <Box
            display="flex"
            flexDirection="column"
            gap="8px"
            padding="20px 24px"
            style={{ background: tokens.TINTS_INFO_80, borderRadius: "14px" }}
          >
            <TooltipTitle>
              {month} {year} Estimated
            </TooltipTitle>
            <TooltipRow>
              <span>Est. energy directly from the Sunrun system</span>
              <span>{Math.round(selfSupply).toLocaleString()} kWh</span>
            </TooltipRow>
            <TooltipRow>
              <span>Est. energy remaining from the utility</span>
              <span>{Math.round(utilityImport).toLocaleString()} kWh</span>
            </TooltipRow>
          </Box>
          <Arrow />
        </div>
      </foreignObject>
    </g>
  );
};

export {
  SelfSupplyTooltipFlyout,
  TOOLTIP_WIDTH,
  TOOLTIP_HEIGHT,
  CARD_HEIGHT,
  ARROW_HEIGHT,
  ARROW_HALF_BASE,
};
